import React from "react";
import {Grid, Slider, Typography} from "@mui/material";
import {useTheme} from "../../../contexts/theme";

interface StyledRangeSliderProps {
    value: [number , number];
    onChange(event: Event, newValue: number[] | number, activeThumb: number): void
    min: number,
    max: number,
    measureUnit?: string,
    scaleFactor?: number,
    step?: number,
    centredInterval: boolean
    valueLabelDisplay: 'auto' | 'off' | 'on'
    formatLabel: (value: number) => string
    labelSlider?: string
    centerValue?: number;
    minLabel?: string,
    maxLabel?: string,
}

const StyledRangeSlider: React.FC<StyledRangeSliderProps> = ({formatLabel, step, valueLabelDisplay, value, min, max, onChange, measureUnit, scaleFactor, centredInterval, labelSlider, centerValue = 0, maxLabel = "Max", minLabel = "Min"}) => {

    const theme = useTheme();
    const gridContainerSx = {display: 'flex', flexDirection: 'column', justifyContent: 'center'}
    const titleStyle = {color: theme.palette.white, fontSize: theme.fontSizes.subParagraphTitle, fontWeight: 'bold', textAlign: 'center'};
    const valueStyle = {color: theme.palette.lightGrey, fontSize: theme.fontSizes.subParagraphTitle,textAlign: 'center'};


    function handleChange(event: Event, newValue: number | number[], activeThumb: number) {
        const scaledValue = newValue as number[];
        scaledValue[0] = (scaledValue[0] < -centerValue) ? scaledValue[0] : -centerValue
        scaledValue[1] = (scaledValue[1] > centerValue) ? scaledValue[1] : centerValue
        onChange(event, [scaledValue[0] * (scaleFactor ? scaleFactor : 1), scaledValue[1]*(scaleFactor ? scaleFactor : 1)], activeThumb);
    }

    return (
        <Grid container sx={{ width: '100%' }}>
            <Grid item md={0} lg={2.5} sx={gridContainerSx}>
                <Grid container direction="column">
                    <Grid lg={6} item>
                        <Typography sx={titleStyle}>{minLabel}</Typography>
                    </Grid>
                    <Grid lg={6} item>
                        <Typography sx={valueStyle}>{formatLabel(value[0])}</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item md={12} lg={7}>
                {/* Aggiunta della label sopra lo slider */}
                <Typography
                    sx={{
                        color: theme.palette.white,
                        fontWeight: 'bold',
                        textAlign: 'center',
                        marginBottom: '8px' // Spaziatura tra label e slider
                    }}
                >
                    {labelSlider}
                </Typography>
                <Slider
                    value={value}
                    onChange={handleChange}
                    valueLabelDisplay={valueLabelDisplay}
                    valueLabelFormat={formatLabel}
                    min={min}
                    max={max}
                    step={step ? step : 1}
                    sx={{
                        color: 'green', // Color for the thumb and track when active
                        '& .MuiSlider-thumb': {
                            backgroundColor: theme.palette.orange,   // Thumb color
                        },
                        '& .MuiSlider-track': {
                            backgroundColor: theme.palette.orange, // Track color
                        },
                        '& .MuiSlider-rail': {
                            backgroundColor: theme.palette.lightGrey,   // Inactive track (rail) color
                        },
                    }}
                />
            </Grid>
            <Grid item md={0} lg={2.5} sx={gridContainerSx}>
                <Grid container direction="column">
                    <Grid lg={6} item>
                        <Typography sx={titleStyle}>{maxLabel}</Typography>
                    </Grid>
                    <Grid lg={6} item>
                        <Typography sx={valueStyle}>{formatLabel(value[1])}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>


    );
};

export default StyledRangeSlider;